module.exports = __webpack_public_path__ + "img/finished.65eb9128.png";